'use strict';

angular.module('internal.users', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // users tab            
            .state('internal.licensing.user', {
                abstract: true,
                templateUrl: paths.app + 'users/components/user/user.html',
                controller: 'InternalUser',
                params: {
                    id: null,
                    user: null
                }
            })
            .state('internal.licensing.user.investigations', {
                url: '/user/:id/investigations',
                templateUrl: paths.app + 'users/components/user-investigations/user-investigations.html',
                controller: 'InternalUserInvestigations',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.services', {
                abstract: true,
                templateUrl: paths.app + "users/layouts/user-services.html"
            })
            .state('internal.licensing.user.services.longevities', {
                url: '/user/:id/longevities',
                templateUrl: paths.app + 'users/components/user-services-longevities/user-services-longevities.html',
                controller: 'InternalUserServicesLongevities',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.services.longevity', {
                url: '/user/:id/longevity/:longevityID',
                templateUrl: paths.app + 'users/components/user-services-longevity/user-services-longevity.html',
                controller: 'InternalUserServicesLongevity',
                params: {
                    id: null,
                    user: null,
                    longevityID: null,
                    longevity: null
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;

                        var method = 'view';
                        if ($stateParams.longevityID == null) {
                            method = 'add';
                        }

                        return Permissions[method]('internal.licensing.user.services.longevities').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.history', {
                url: '/user/:id/history',
                templateUrl: paths.app + 'users/components/user-history/user-history.html',
                controller: 'InternalUserHistory',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.exams', {
                url: '/user/:id/exams',
                templateUrl: paths.app + 'users/components/user-exams/user-exams.html',
                controller: 'InternalUserExams',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.backgroundchecks', {
                url: '/user/:id/backgroundCheckHistory',
                templateUrl: paths.app + 'users/components/user-backgroundChecks/user-backgroundChecks.html',
                controller: 'InternalUserBackgroundChecks',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.education', {
                url: '/education/user/:id',
                templateUrl: paths.app + 'users/components/user-education/user-education.html',
                controller: 'InternalUserEducation',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.educationCourseList', {
                url: '/education/userCourseList/:id',
                templateUrl: paths.app + 'users/components/user-education/user-education.html',
                controller: 'InternalUserEducation',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.certifications', {
                abstract: true,
                templateUrl: paths.app + 'users/layouts/user-certifications.html',
            })
            .state('internal.licensing.user.certifications.history', {
                url: '/users/:id/certifications/history',
                templateUrl: paths.app + 'users/components/user-certifications/user-certifications-history.html',
                controller: 'InternalUserCertificationsHistory',
                params: {
                    id: null,
                    licenseCategoryId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.user.integrations', {
                abstract: true,
                templateUrl: paths.app + "users/layouts/user-integrations.html"
            })
            .state('internal.licensing.user.integrations.settings', {
                url: '/users/:id/integrations/settings',
                templateUrl: paths.app + 'users/components/user-certifications/user-certifications-history.html',
                controller: 'InternalUserCertificationsHistory',
                params: {
                    id: null,
                    user: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
    }])
    ;